type RafGate = {
    trigger: () => void;
    cancel: () => void;
};

/**
 * Creates a requestAnimationFrame gate that runs the callback at most once per frame.
 *
 * @param fn - Callback to run on the next animation frame.
 * @returns Trigger and cancel functions for the gate.
 */
export const createRafGate = (fn: () => void): RafGate => {
    let rafId = 0;

    const trigger = () => {
        if (rafId) return;

        rafId = requestAnimationFrame(() => {
            rafId = 0;
            fn();
        });
    };

    const cancel = () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
    };

    return { trigger, cancel };
};
